<template>
  <div v-if="isOpen" class="module-modal-overlay">
    <div :class="['module-modal-container', sizeClass]">
      <!-- Header -->
      <div class="module-modal-header">
        <span class="custom-danger">{{ title }}</span>
        <!-- Botón X al extremo derecho -->
        <button class="close-btn" @click="$emit('close')">✕</button>
      </div>

      <!-- Body -->
      <div class="module-modal-body">
        <slot name="body"></slot>
      </div>

      <!-- Footer -->
      <div class="module-modal-footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    title: { type: String, default: '' },
    isOpen: { type: Boolean, required: true },
    size: {
      type: String,
      default: 'sm',
      validator: val => ['sm', 'md', 'lg'].includes(val)
    }
  },
  computed: {
    sizeClass() {
      return `modal-size-${this.size}`
    }
  }
}
</script>

<style scoped>
.modal-size-sm {
  min-width: 25%;
}
.modal-size-md {
  min-width: 60%;
}
.modal-size-lg {
  min-width: 80%;
}

.module-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  overflow: hidden;
}

.module-modal-container {
  background: #fff;
  border-radius: 5px;
  width: auto;
  max-width: 90%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  animation: module-modal-fadeIn 0.25s ease;
  overflow: hidden;
}

.module-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #f0f0f0;
  font-size: 20px;
}

.close-btn {
  border: none;
  background: transparent;
  font-size: 22px;
  cursor: pointer;
  line-height: 1;
  color: #626262;
}
.close-btn:hover {
  color: #d01500;
}

.module-modal-body {
  padding: 1rem;
}

.module-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 0.75rem 1.25rem;
  border-top: 1px solid #f0f0f0;
}

@keyframes module-modal-fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Bloquear scroll de la ventana mientras el overlay exista */
:global(body:has(.module-modal-overlay)) {
  overflow: hidden;
}
</style>